<div style="height: 12%">
  <app-upload-wrapper
    readAs="ArrayBuffer"
    [maxSize]="10000000"
    [accept]="'.pdf'"
    (changed)="onDocumentUploaded($event)"
  />
</div>


<kpi4me-cart-document-detail
  [style.height.%]="trapoDetailHasNoRows() ? 88 : 44"
  [hidden]="cartDocumentDetailHasNoRows()"
  (rowCreated)="uploadDocument($event)"
  (detailDocumentToggleTriggered)="detailDocumentToggleTriggered.emit($event)"
  (rowSelected)="onDocumentRowSelected()"
/>

<kpi4me-trapo-detail
  [style.height.%]="cartDocumentDetailHasNoRows() ? 88 : 44"
  [hidden]="trapoDetailHasNoRows()"
  (detailTrapoDocumentToggleTriggered)="detailDocumentToggleTriggered.emit($event)"
  (rowSelected)="onTrapoRowSelected()"
/>
